import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { modalFormStyles } from "../../../assets/styles/tableContainer";
import { TextArea, TextSelector } from "../../../components/Fields/TextFields";
import jsonMap from "../../../components/Utils/jsonMap";
import { isPhysician } from "./isgProfessionalPayload";

const useStyles = makeStyles((theme) => ({
  ...modalFormStyles(theme),
  title: {
    marginBottom: "1vw",
  },
  clearBox: {
    marginBottom: "1vw",
  },
}));

function SecretField({
  label,
  value,
  onChange,
  className,
  required,
  error,
  helperText,
  clearLabel,
  cleared,
  onClearedChange,
}) {
  const [visible, setVisible] = React.useState(false);

  return (
    <>
      <TextField
        fullWidth
        required={required}
        disabled={cleared}
        error={Boolean(error)}
        helperText={error || helperText}
        type={visible ? "text" : "password"}
        label={label}
        value={value}
        onChange={onChange}
        className={className}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                disabled={cleared}
                aria-label={visible ? "Gizle" : "Göster"}
                title={visible ? "Gizle" : "Göster"}
                onClick={() => setVisible(!visible)}
                onMouseDown={(event) => event.preventDefault()}
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {onClearedChange && (
        <FormControlLabel
          control={
            <Checkbox
              checked={cleared}
              onChange={(event) => onClearedChange(event.target.checked)}
            />
          }
          label={clearLabel}
        />
      )}
    </>
  );
}

export default function IsgProfessionalForm({
  form,
  setForm,
  errors,
  row,
  loading,
  options,
  onSubmit,
}) {
  const classes = useStyles();
  const isEdit = Boolean(row);
  const physician = isPhysician(form.documentType);

  const change = (field) => (event) =>
    setForm({ ...form, [field]: event.target.value });

  const changeCleared = (valueField, flagField) => (checked) =>
    setForm({ ...form, [flagField]: checked, [valueField]: "" });

  const keepHint = isEdit
    ? "Boş bırakılırsa mevcut değer korunur."
    : undefined;

  return (
    <FormControl noValidate autoComplete="off" className={classes.formControl}>
      <Typography variant="h6" className={classes.title}>
        {isEdit
          ? "OSGB İzleme Kullanıcısını Düzenle"
          : "Yeni OSGB İzleme Kullanıcısı"}
      </Typography>

      <TextSelector
        required
        disabled={isEdit}
        label={"Belge Tipi"}
        value={form.documentType}
        onChangeFunc={change("documentType")}
        error={errors.documentType}
        style={classes.textField}
        options={jsonMap(false, options.documentTypes)}
      />

      <TextArea
        required
        disabled={isEdit}
        label={"TC No"}
        value={form.tcNo}
        onChangeFunc={change("tcNo")}
        error={errors.tcNo}
        style={classes.textField}
      />

      <TextArea
        required
        label={"Ad"}
        value={form.firstName}
        onChangeFunc={change("firstName")}
        error={errors.firstName}
        style={classes.textField}
      />

      <TextArea
        required
        label={"Soyad"}
        value={form.lastName}
        onChangeFunc={change("lastName")}
        error={errors.lastName}
        style={classes.textField}
      />

      <TextArea
        label={"Branş Kodu"}
        value={form.branch}
        onChangeFunc={change("branch")}
        error={errors.branch}
        style={classes.textField}
      />

      <TextArea
        required={physician}
        label={"Plaka"}
        value={form.plate}
        onChangeFunc={change("plate")}
        error={errors.plate}
        style={classes.textField}
      />

      <SecretField
        required={physician}
        label={"Medula Parolası"}
        value={form.medulaPassword}
        onChange={change("medulaPassword")}
        className={classes.textField}
        error={errors.medulaPassword}
        helperText={keepHint}
        clearLabel={"Medula parolasını iptal et"}
        cleared={form.clearMedulaPassword}
        onClearedChange={
          isEdit && row.medulaPasswordDefined && !physician
            ? changeCleared("medulaPassword", "clearMedulaPassword")
            : undefined
        }
      />

      <SecretField
        label={"E-İmza Kart PIN"}
        value={form.cardPin}
        onChange={change("cardPin")}
        className={classes.textField}
        helperText={keepHint}
        clearLabel={"E-imza PIN'ini iptal et"}
        cleared={form.clearCardPin}
        onClearedChange={
          isEdit && row.signaturePinDefined
            ? changeCleared("cardPin", "clearCardPin")
            : undefined
        }
      />

      <div style={{ textAlign: "center" }}>
        {loading ? (
          <CircularProgress color="secondary" />
        ) : (
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={onSubmit}
            className={classes.submit}
          >
            {isEdit ? "Güncelle" : "Oluştur"}
          </Button>
        )}
      </div>
    </FormControl>
  );
}
